import { observeNotification } from '../Notification';
import { Observable } from '../Observable';
import { createOperatorSubscriber } from './OperatorSubscriber';
export function dematerialize() {
    return function (source) {
        return new Observable(function (subscriber) {
            source.subscribe(createOperatorSubscriber(subscriber, function (notification) { return observeNotification(notification, subscriber); }));
        });
    };
}
//# sourceMappingURL=dematerialize.js.map